import React from "react";
import { useUserAuth } from "../context/AuthContext";

interface authenticatedComponentProps {
    authenticatedComponent: React.ReactElement;
    unauthenticatedComponent: React.ReactElement;
}

export default function ConditionalRoute({ authenticatedComponent, unauthenticatedComponent }: authenticatedComponentProps): React.ReactElement | null {
    const { user, loading } = useUserAuth();
    if (loading) {
        return null;
    }

    return user ? authenticatedComponent : unauthenticatedComponent;
}
